import React from "react";
import "../routes/enrollment/electiveCard.css";

const ElectiveCard = ({
  subject,
  isSelected,
  isHovered,
  onClick,
  onMouseEnter,
  onMouseLeave,
  width, // optional
}) => {
  return (
    <div
      className={`elective-card card shadow mb-4 w-100${isSelected ? ' selected' : ''}${isHovered ? ' hovered' : ''}`}
      style={width ? { width } : undefined} // 👈 Only override if width is provided
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="elective-card-content">
        <span className="elective-card-title">{subject.name}</span>
      </div>
    </div>
  );
};

export default ElectiveCard;
